"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _rawButton = _interopRequireDefault(require("@paprika/raw-button"));

var types = _interopRequireWildcard(require("../../types"));

var ButtonComponentMap = {
  icon: _button["default"].Icon,
  raw: _rawButton["default"],
  simple: _button["default"]
};

var TriggerButton = function TriggerButton(props) {
  var isConfirmOpen = props.isConfirmOpen,
      children = props.children,
      onOpenConfirm = props.onOpenConfirm,
      triggerRef = props.triggerRef,
      buttonType = props.buttonType,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["isConfirmOpen", "children", "onOpenConfirm", "triggerRef", "buttonType"]);
  var TriggerComponent = ButtonComponentMap[buttonType];
  return /*#__PURE__*/_react["default"].createElement(TriggerComponent, (0, _extends2["default"])({
    "data-pka-anchor": "button",
    ref: triggerRef,
    "aria-expanded": isConfirmOpen,
    "aria-haspopup": "true",
    isSemantic: false,
    onClick: onOpenConfirm
  }, moreProps), children);
};

TriggerButton.types = {
  button: types.buttonTypes
};
var propTypes = {
  children: _propTypes["default"].node,
  buttonType: _propTypes["default"].oneOf([TriggerButton.types.button.ICON, TriggerButton.types.button.RAW, TriggerButton.types.button.SIMPLE]),
  isConfirmOpen: _propTypes["default"].bool,
  onOpenConfirm: _propTypes["default"].func,
  triggerRef: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Object)
  })
};
var defaultProps = {
  buttonType: TriggerButton.types.button.SIMPLE,
  children: null,
  isConfirmOpen: false,
  onOpenConfirm: function onOpenConfirm() {},
  triggerRef: null
};
TriggerButton.displayName = "Confirmation.TriggerButton";
TriggerButton.propTypes = propTypes;
TriggerButton.defaultProps = defaultProps;
var _default = TriggerButton;
exports["default"] = _default;
//# sourceMappingURL=TriggerButton.js.map